module.exports = __webpack_public_path__ + "62zMRbUQkDDyPCw-E/RDC_RED_Logo_House.svg";